import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">GTBuy Spreadsheet</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your all-in-one order tracking and management system for GTBuy, Kakobuy, and Superbuy platforms.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Home</Link>
              </li>
              <li>
                <Link to="/what-is-gtbuy-spreadsheet" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">What is GTBuy Spreadsheet</Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">gtbuy sheet</a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">External Resources</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">Buy it now</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">Shoes Category</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-background-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} GTBuy Spreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            Optimized for <strong>GTBuy</strong>, <strong>Kakobuy</strong>, and <strong>Superbuy</strong> order management.
          </p>
        </div>
      </div>
    </footer>
  );
}